var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 339,
    viewBox: "0 0 446 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 146,
    r: 146,
    fill: "#01487C",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.192 120.908C152.718 110.44 164.062 104.812 174.53 108.338L276.88 142.811C287.348 146.337 292.976 157.681 289.45 168.149L286.258 177.626L146 130.384L149.192 120.908Z",
    fill: "#01487C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.277 106.571C217.159 103.954 219.995 102.547 222.612 103.429L241.566 109.813C244.183 110.694 245.59 113.53 244.708 116.147C243.827 118.764 240.991 120.171 238.374 119.29L219.42 112.906C216.803 112.024 215.396 109.188 216.277 106.571Z",
    fill: "#01487C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.859 339L138 206H170.859H253.006H285.865L253.006 339H170.859ZM180.602 230.258C180.257 227.816 178.166 226 175.7 226C172.69 226 170.376 228.663 170.797 231.644L182.398 313.742C182.743 316.184 184.834 318 187.3 318C190.31 318 192.624 315.337 192.203 312.356L180.602 230.258ZM212 226C209.239 226 207 228.239 207 231V313C207 315.761 209.239 318 212 318C214.761 318 217 315.761 217 313V231C217 228.239 214.761 226 212 226ZM248.3 226C245.834 226 243.743 227.816 243.398 230.258L231.797 312.356C231.376 315.337 233.69 318 236.7 318C239.166 318 241.257 316.184 241.602 313.742L253.203 231.644C253.624 228.663 251.31 226 248.3 226Z",
    fill: "#01487C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7948 151.433L47.8327 146.048L56.6175 143L57.5139 145.51L49.4462 147.841L48.1203 151.818L60.9203 153.936L56.9761 163.08L62.5339 171.865L55.9004 179.753L56.9761 188H37.4343L36 179.753L40.3028 171.865L36 163.08V149.813L45.7948 151.433Z",
    fill: "#01487C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03131 184.934L4.21878 186.224L5.18598 188.333L0.967195 190.268L11.284 212.768L22.5341 207.61L12.2173 185.109L7.9985 187.044L7.03131 184.934Z",
    fill: "#01487C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.899 145.077L143.231 176.672L111.226 185.651L119.008 171.081C115.974 169.417 111.687 167.571 103.947 166.545C92.6537 165.047 84.2104 168.473 84.2104 168.473C85.0942 166.111 89.3931 158.771 101.542 156.19C111.059 154.169 119.544 156.625 125.318 159.268L132.899 145.077Z",
    fill: "#01487C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.a42c1ddae70e18450ca056136430358f.svg";
export { ForwardRef as ReactComponent };